<div #chartdivperformancebalance class="w-full h-60 md:h-96"></div>
<bp-tooltip-chart #tool class="hidden" [tooltip]="tooltip"></bp-tooltip-chart>
